import { useState } from 'react';
import './style.css';
import { BiEdit } from 'react-icons/bi';
import ModalBtn from '../../molecules/modalButton/view';
import ProductForm from '../ProductForm/view';
import { editProduct } from '../../../usecases/products-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';

const EditProduct = ({ data, hidden = false, profile, modalId }) => {
  const [initialData, setInitialData] = useState({});

  const targetModalId = modalId || ('edit-product-' + (data.sku || data.id));

  function handleOpen() {
    setInitialData({
      sku: data.sku,
      name: data.name,
      buy_value: data.buy_value,
      value: data.value,
      stock: data.stock,
      sell_taxes_id: data.sell_taxes_id,
      buy_taxes_id: data.buy_taxes_id,
      unit_of_measure: data.unit_of_measure || 70,
      warranty: data.warranty || '',
    });
  }

  function handleSubmit(formData) {
    const payload = { ...formData, enable: data.enable };
    editProduct(profile.uid, profile.cid, payload, data.id)
      .then((res) => {
        const updatedData = { id: data.id, ...data, ...payload, ...(res?.data || res || {}) };
        dispatchCustomEvent('product-edited', updatedData);
        dispatchCustomEvent('popup', {
          message: 'Producto actualizado correctamente',
        });
        dispatchCustomEvent('loading-btn-' + targetModalId, null);
        dispatchCustomEvent('modal-close-' + targetModalId, {});
      })
      .catch((error) => {
        dispatchCustomEvent('loading-btn-' + targetModalId, null);
        const err = error.response?.data?.message;
        const messages = {
          limit_reached: 'Has alcanzado el límite de productos en tu plan.',
          product_exist: 'Ya existe un producto con este SKU.',
        };
        dispatchCustomEvent('popup', {
          message: messages[err] || 'Error al actualizar producto',
          type: 'error',
        });
      });
  }

  return (
    <ModalBtn
      id={targetModalId}
      title={<BiEdit size={18} />}
      type="action"
      hidden={hidden}
      onClick={handleOpen}
      modalTitle="Editar Producto"
      style={{ border: 'none' }}
    >
      <ProductForm
        mode="edit"
        initialData={initialData}
        onSubmit={handleSubmit}
        submitId={targetModalId}
        submitLabel="Guardar cambios"
      />
    </ModalBtn>
  );
};

export default EditProduct;
